// extracted by mini-css-extract-plugin
export default {"list":"Navigation_list__hY2hZ","item":"Navigation_item__PQCMi","link":"Navigation_link__Jlf0e"};